import type { EmptyObject, Middleware } from '@reduxjs/toolkit'
import { loadTrashContent, updateTrashContent } from '~/API/job'
import { TRASH_FETCH_LIMIT } from '~/config/constants'
import { isCurrentLocationMatching } from '~/utilities/navigation'
import { RoutePath } from '~/routing/routePath'
import {
    FilesDeletionSucceeded,
    FilesRestorationSucceeded,
} from '../job/actions'
import { getTimelineJobID } from '../timeline/selectors'
import { timelineReducerMapObj } from '../timeline/reducers'
import { FetchMoreTrashTriggered } from './actions'
import { getTrashFileLatestOffset } from './selectors'
import { trashReducerMapObj } from './reducer'

export const trashMiddlewareReducerMapObj = {
    ...timelineReducerMapObj,
    ...trashReducerMapObj,
}

type TrashMiddlewareState = StateOfReducerMapObj<
    typeof trashMiddlewareReducerMapObj
>

export const trashMiddleware: Middleware<EmptyObject, TrashMiddlewareState> =
    (store) => (next) => (action) => {
        if (isCurrentLocationMatching(RoutePath.TrashPhotos)) {
            const state = store.getState()
            const timelineID = getTimelineJobID(state)
            const latestOffset = getTrashFileLatestOffset(state)

            if (
                (FilesDeletionSucceeded.match(action) ||
                    FilesRestorationSucceeded.match(action)) &&
                action.payload.jobID === timelineID
            ) {
                updateTrashContent(
                    store.dispatch,
                    latestOffset,
                    TRASH_FETCH_LIMIT,
                )
            }

            // TODO(CAPWEB-3274): replace update logic with FilesRestorationSucceeded
            // if (
            //     FilesWereAddedToJob.match(action) &&
            //     action.payload.jobID === timelineID &&
            //     action.payload.files.some((f) => f.is_rollback === true)
            // ) {
            //     updateTrashContent(
            //         store.dispatch,
            //         latestOffset,
            //         TRASH_FETCH_LIMIT,
            //     )
            // }

            if (FetchMoreTrashTriggered.match(action)) {
                loadTrashContent(
                    store.dispatch,
                    latestOffset + TRASH_FETCH_LIMIT,
                    TRASH_FETCH_LIMIT,
                )
            }
        }

        next(action)
    }
